module.exports = "/_next/static/images/OgCatalog-dc0f7c2b805a516d6a707c1c0572b09f.png";